/* -----------------Child components--------------- */
import DocumentTitle from "components/DocumentTitle";

import { isProethicaTestId } from "@constants/demo/proethica-tests";
/* -----------------Types--------------- */
import { events } from "@constants/tracking";
import { pageViewTypes } from "@constants/tracking";
import { ProethicaTestReport, ReportContainer } from "@features/report";
import { useProethicaPretestScore } from "@features/report/hooks/useProethicaPretestScore";
import { useProethicaReportSession } from "@features/report/hooks/useProethicaReportSession";
import { useSessionStore } from "@features/session";
import { BottomSheetModalProvider } from "@gorhom/bottom-sheet";
import useAnalytics from "@hooks/useAnalytics";
import { EmptyState, Loader } from "@memorang/ui";

const ReportRoute = () => {
	useAnalytics({
		type: pageViewTypes.report,
		eventName: events.reportViewed,
	});

	const { hydrating, hydrateError, retryHydrate } = useProethicaReportSession();

	const isProethicaTest = useSessionStore((state) =>
		isProethicaTestId(state.moduleId),
	);
	const isPostTest = useSessionStore(
		(state) => state.proethicaTestKind === "posttest",
	);

	const { pretestScore, isLoading: pretestScoreLoading } =
		useProethicaPretestScore(hydrating || isPostTest);
	const loading = hydrating || (isPostTest && pretestScoreLoading);

	return (
		<>
			<BottomSheetModalProvider>
				<DocumentTitle title={"Report"} />
				{hydrateError ? (
					<EmptyState
						title="We couldn't load this report."
						subtitle="Please try again."
						cta="Retry"
						handleAction={() => retryHydrate()}
					/>
				) : loading ? (
					<Loader />
				) : isProethicaTest ? (
					<ProethicaTestReport pretestScore={pretestScore} />
				) : (
					<ReportContainer />
				)}
			</BottomSheetModalProvider>
		</>
	);
};

export default ReportRoute;
